export const oneCapitalCharRequiredRegExp = new RegExp(/[A-Z]/);
export const atLeastOneNumberRequiredRegExp = new RegExp(/[0-9]/);
export const oneSpecialCharacterRequiredRegExp = new RegExp(/[-_&.$]/);

export const onlySymbolAndNumbersRegExp = new RegExp(/^[0-9A-Za-z]+$/);
export const qsChannelTitleRegExp = new RegExp(/^[0-9A-Za-z-_&. ]+$/);

export const bracesRegExp = new RegExp(/[^{][A-Za-z]*(?=\})/gm);
